import { DisplayAddress } from "../../../types";
import React from "react";
import { colors, Text } from "@commonsku/styles";
import styled from "styled-components";
import { toTitleCase } from "../../../utils";

// Address Box/Container Style
const AddressCard = styled.div<{ $active?: boolean }>`
  &&& {
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    width: 230px;
    height: fit-content;
    min-height: 192px;
    cursor: pointer;
    padding: 16px;
    background: ${(props) => (props.$active ? colors.primary1[10] : colors.neutrals[20])};
  }
`;

// Style for all text used in the address card
const AddressText = styled(Text) <{ $bold?: boolean, $active?: boolean }>`
  word-wrap: break-word;
  line-height: ${(props) => (props.$bold ? "32px" : "28px")};
  font-size: ${(props) => (props.$bold ? "16px" : "14px")};
  font-weight: ${(props) => (props.$bold ? "700" : "400")};
  font-family: ${(props) => (props.$bold ? "skufont-demibold" : "skufont-regular")};
  color: ${(props) => (props.$active ? colors.primary1.main : colors.neutrals[70])};
`;

export interface AddressSummaryProps {
  address: DisplayAddress;
  onClick: (address: DisplayAddress) => void;
}

export const AddressSummary = ({ address, onClick }: AddressSummaryProps) => {
  return (
    <AddressCard
      $active={address.active}
      data-testid={"Address-card-" + address.id}
      onClick={() => onClick(address)}
    >
      <AddressText $bold $active={address.active}>
        {address.name ? address.name : "Address"}
      </AddressText>
      <AddressText $active={address.active}>
        {address.address_line_1}
      </AddressText>
      <AddressText $active={address.active}>
        {address.address_line_2}
      </AddressText>

      <AddressText $active={address.active}>
        {[address.city, address.state, address.country]
          .filter((x) => x)
          .join(", ")}
      </AddressText>
      {address.postal && (
        <AddressText $active={address.active}>{address.postal}</AddressText>
      )}
    </AddressCard>
  );
};
